import { render, staticRenderFns } from "./IsStockist.vue?vue&type=template&id=fb0ecfd4&"
import script from "./IsStockist.vue?vue&type=script&lang=js&"
export * from "./IsStockist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports